<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-layout pl-2 pt-2 pr-2 pb-2 justify-center row>
    <v-flex xs2>
      <SimpleCard>
        <CustomerSearchBox @search="search" @clear="clear" :query="query"></CustomerSearchBox>
      </SimpleCard>
    </v-flex>
    <v-flex xs10 pl-2>
      <SimpleCard>
        <v-layout row wrap align-content-center justify-center>
          <CustomerList
            style="width: 100%;"
            :customers="customers"
            :paginationProp="pagination"
            :loading="loading"
          ></CustomerList>
          <v-flex v-if="!loading" pt-2 xs9 class="text-xs-center pt-2">
            <v-pagination
              @input="changePage"
              v-model="pagination.page"
              :length="num_pages"
              :total-visible="10"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </SimpleCard>
    </v-flex>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import CustomerList from "@/components/customer/CustomerList.vue";
import CustomerSearchBox from "@/components/customer/CustomerSearchBox.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "customers",
  components: {
    SimpleCard,
    CustomerList,
    CustomerSearchBox
  },

  data: function() {
    return {
      offset: 0,
      count: 20,
      query: {
        search: "",
        lockedOut: false
      },
      loading: true,
      pagination: { page: 1 },
      num_pages: 0,
      customers: []
    };
  },
  mounted: async function() {
    this.getCustomers();
  },
  methods: {
    search: function() {
      this.pagination.page = 1;
      this.getCustomers();
    },
    clear: function() {
      this.query = {
        search: "",
        lockedOut: false
      };
    },
    changePage: function(page) {
      this.pagination.page = page;
      console.log(page);
      this.getCustomers();
    },
    getCustomers: async function() {
      this.loading = true;

      try {
        let url = `${this.$store.state.apiUrl}/customer/list?offset=${this
          .count *
          (this.pagination.page - 1)}&count=${this.count}
        &query=${this.query.search}&lockedOut=${this.query.lockedOut}`;

        let response = await axios.get(url, {
          params: {}
        });

        let users = response.data.users;

        this.customers = users;

        this.pagination.page = response.data.pages.page;
        this.num_pages = response.data.pages.num_pages;

        console.log(response.data.num_pages);

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get customers " + error);
      }
    }
  }
};
</script>
